import * as React from "react";
function SvgCheck(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={4}
        stroke="currentColor"
        d="M2 16l10 10L30 8"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgCheck);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
